module.exports = __webpack_public_path__ + "img/d6-active.0b016090.png";